/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import _forEach from 'lodash/forEach';
import utilityService from './utility.service';
import { getKeyValueFromLocalStorage } from './localstorage/getKeyValueFromLocalStorage';
import { getSettingFromLocalstorage } from './localstorage/getSettingFromLocalstorage';
import { setKeyValueInLocalStorage } from './localstorage/setKeyValueInLocalStorage';
import AppConst from '../constants/app.constant';
import * as AltitudeOptionsConst from '../constants/altitude.constant';

const otuService = () => {
  const contents = {};
  contents.doOneTimeUpdate = () => {
    let lsOtuOn = getKeyValueFromLocalStorage(AppConst.localstorageConf
      .lastOtuOn);
    const myMeteoPreviousSettings = getSettingFromLocalstorage(
      AppConst.localstorageConf.meteogramSettingKey,
    );
    const myApplicationPreviousSettings = getSettingFromLocalstorage(
      AppConst.localstorageConf.applicationSettingKey,
    );
    const myDevicePreviousSettings = getSettingFromLocalstorage(
      AppConst.localstorageConf.deviceSpecificSettingKey,
    );
    // Uncomment below line when this service has to tackle routeprofile settings also.
    const myRouteprofilePreviousSettings = getSettingFromLocalstorage(
      AppConst.localstorageConf.routeprofileSettingKey,
    );
    if (lsOtuOn !== null) {
      // Parse it to Integer
      lsOtuOn = parseInt(lsOtuOn, 10);
    }
    if (lsOtuOn === null || lsOtuOn < AppConst.oneTimeUpdateKey) {
      if (lsOtuOn < 20170507) {
        const maxAllowedToUse = AltitudeOptionsConst.MSL12K.feet;

        if (myMeteoPreviousSettings && myMeteoPreviousSettings.maximumAltitudeAllowed) {
          myMeteoPreviousSettings.maximumAltitudeAllowed = maxAllowedToUse;
        }
        if (myRouteprofilePreviousSettings) {
          myRouteprofilePreviousSettings.maximumAltitudeAllowed = maxAllowedToUse;
        }
      }
      if (lsOtuOn < 20170601) {
        // Removing all grib:aloft records from localStorage
        const localStorageKeys = Object.keys(localStorage);
        _forEach(localStorageKeys, (item) => {
          if (item.indexOf(AppConst.localstorageConf.gribCacheKey) > -1) {
            localStorage.removeItem(item);
          }
        });
      }
      if (lsOtuOn < 20170608) {
        localStorage.removeItem('bn_fullData_meteogram');
        localStorage.removeItem('bn_fullData_routeprofile');
        localStorage.removeItem('bn_fullData_gridview');
      }
      if (lsOtuOn < 20171215) {
        localStorage.removeItem('bn_sevenDayApiUrlsMapping');
      }
      if (lsOtuOn < 20180104) {
        if (myMeteoPreviousSettings) {
          myMeteoPreviousSettings.actionKey = 'meteogram';
        }
      }
      if (lsOtuOn < 20180110) {
        // localStorage.removeItem('bn_airportTab');
      }
      if (lsOtuOn < 20180124) {
        if (myDevicePreviousSettings) {
          myDevicePreviousSettings.enableSubscription = false;
        }
      }
      if (lsOtuOn < 20180420) {
        const maxAllowedToUse = AltitudeOptionsConst.MSL12K.feet;

        if (myMeteoPreviousSettings && myMeteoPreviousSettings.maximumAltitudeAllowed) {
          myMeteoPreviousSettings.maximumAltitudeAllowed = maxAllowedToUse;
        }
        if (myRouteprofilePreviousSettings) {
          myRouteprofilePreviousSettings.maximumAltitudeAllowed = maxAllowedToUse;
        }
      }
      if (lsOtuOn < 20180625) {
        if (myApplicationPreviousSettings) {
          myApplicationPreviousSettings.groundSpeed = parseInt(myApplicationPreviousSettings
            .groundSpeed, 10);
          if (
            Number.isNaN(myApplicationPreviousSettings.groundSpeed)
            || myApplicationPreviousSettings.groundSpeed < AppConst.minGroundSpeed
            || myApplicationPreviousSettings.groundSpeed > AppConst.maxGroundSpeed
          ) {
            myApplicationPreviousSettings.groundSpeed = AppConst.defaultGroundSpeed;
          }
        }
        if (myDevicePreviousSettings) {
          myDevicePreviousSettings.enableMetars = true;
        }
      }
      if (lsOtuOn < 20190516) {
        if (myRouteprofilePreviousSettings) {
          if (typeof myRouteprofilePreviousSettings.showHeadWindOnly === 'string') {
            if (myRouteprofilePreviousSettings.showHeadWindOnly === 'true') {
              myRouteprofilePreviousSettings.showHeadWindOnly = true;
            } else {
              myRouteprofilePreviousSettings.showHeadWindOnly = false;
            }
          }
        }
      }
      if (lsOtuOn < 20190608) {
        // localStorage.removeItem('bn_imagerySetting');
        if (myRouteprofilePreviousSettings && myRouteprofilePreviousSettings.end) {
          myRouteprofilePreviousSettings.end = myRouteprofilePreviousSettings.end.toUpperCase();
        }
      }
      if (lsOtuOn < 20191014) {
        const maxAllowedToUse = AltitudeOptionsConst.MSL12K.feet;
        if (myMeteoPreviousSettings && !myMeteoPreviousSettings.maximumAltitudeAllowed) {
          myMeteoPreviousSettings.maximumAltitudeAllowed = maxAllowedToUse;
        }
        if (myRouteprofilePreviousSettings) {
          if (!myRouteprofilePreviousSettings.maximumAltitudeAllowed) {
            myRouteprofilePreviousSettings.maximumAltitudeAllowed = maxAllowedToUse;
          }
          if (typeof myRouteprofilePreviousSettings.maximumAltitudeAllowed === 'boolean') {
            myRouteprofilePreviousSettings.maximumAltitudeAllowed = maxAllowedToUse;
          }
          if (typeof myRouteprofilePreviousSettings.showHeadWindOnly === 'string') {
            if (myRouteprofilePreviousSettings.showHeadWindOnly === 'true') {
              myRouteprofilePreviousSettings.showHeadWindOnly = true;
            } else {
              myRouteprofilePreviousSettings.showHeadWindOnly = false;
            }
          }
          if (
            myRouteprofilePreviousSettings.showHeadWindOnly !== true
            && myRouteprofilePreviousSettings.showHeadWindOnly !== false
          ) {
            myRouteprofilePreviousSettings.showHeadWindOnly = AppConst.defaultHeadOnlyWind;
          }
        }
      }
      if (lsOtuOn < 20220118) {
        if (myRouteprofilePreviousSettings && !myRouteprofilePreviousSettings.sliderPinned) {
          myRouteprofilePreviousSettings.sliderPinned = true;
          myRouteprofilePreviousSettings.sliderPinnedOldState = true;
        }
      }
      /** ***PUT new One Time Update Condition above this line**** */
      utilityService.setSettingInLocalstorage(
        myMeteoPreviousSettings,
        AppConst.localstorageConf.meteogramSettingKey,
      );
      utilityService.setSettingInLocalstorage(
        myRouteprofilePreviousSettings,
        AppConst.localstorageConf.routeprofileSettingKey,
      );
      utilityService.setSettingInLocalstorage(
        myApplicationPreviousSettings,
        AppConst.localstorageConf.applicationSettingKey,
      );
      utilityService.setSettingInLocalstorage(
        myDevicePreviousSettings,
        AppConst.localstorageConf.deviceSpecificSettingKey,
      );
      setKeyValueInLocalStorage(
        AppConst.localstorageConf.lastOtuOn,
        AppConst.oneTimeUpdateKey,
      );
    }
  };
  return contents;
};
export default otuService();
